import * as Yup from 'yup';

import { BraceOrderStatus } from '../constants/brace-order-status';
import { BraceType } from '../constants/brace-type';
import { OpeningType } from '../constants/opening-type';
import { IFileUploaded } from './file';
import { IPatientInfo } from './patient';

export interface IBraceOrder {
  id?: string;
  status: BraceOrderStatus;
  patientInfo: IPatientInfo;
  braceInfo: IBraceInfo;
  prescriberName: string;
  clinicName: string;
  prescriptionFiles: IFileUploaded[];
  radiographyFiles: IFileUploaded[];
  scansFiles: IFileUploaded[];
}

export interface IBraceInfo {
  name: string;
  date: Date;
  type: BraceType | string;
  hoursPerDay: number;
  opening: OpeningType | string;
}

export const braceOrderValidationSchema = Yup.object<any, Partial<Record<keyof IBraceOrder, Yup.AnySchema>>>({
  patientInfo: Yup.object<any, Record<keyof IPatientInfo, Yup.AnySchema>>({
    patientId: Yup.string().required(),
    weight: Yup.number()
      .transform((value) => +value)
      .min(1)
      .max(635)
      .required(),
    height: Yup.number()
      .transform((value) => +value)
      .integer()
      .min(1)
      .max(215)
  }),
  braceInfo: Yup.object<any, Record<keyof IBraceInfo, Yup.AnySchema>>({
    name: Yup.string().required(),
    date: Yup.date().required(),
    type: Yup.mixed().oneOf(Object.values(BraceType)).required(),
    hoursPerDay: Yup.number()
      .transform((value) => +value)
      .integer()
      .min(0)
      .max(24)
      .required(),
    opening: Yup.mixed().oneOf(Object.values(OpeningType)).required(),
  }).required(),
  prescriberName: Yup.string().required(),
  clinicName: Yup.string().required(),
  prescriptionFiles: Yup.array().min(0).required(),
  radiographyFiles: Yup.array().min(1).required(),
  scansFiles: Yup.array().min(1).required(),
});
